export const LINKS = {
  amazon: "https://www.amazon.it/?tag=barberlatin0a-21",
  booking: "https://sumupbookings.com/barberlatinojordan",
  pay: "https://pay.sumup.com/b2c/Q8LK31NX",
  whatsapp: "https://wa.me/393889378525",
  reviews: `https://wa.me/393889378525?text=${encodeURIComponent("Ciao! Voglio lasciare una recensione del servizio")}`,
};

export const WHATSAPP_NUMBER = "+39 388 937 8525";
export const WHATSAPP_DIGITS = "393889378525";
export const BUSINESS_NAME = "Barber Latin";

// Abre apps externas desde la PWA instalada: en Android usa intent:// (sin ventanas negras),
// en el resto navega a la URL web normal.
export const openExternal = (webUrl, intentUrl) => (e) => {
  if (e && e.preventDefault) e.preventDefault();
  if (/android/i.test(navigator.userAgent) && intentUrl) {
    window.location.href = intentUrl;
  } else {
    window.location.href = webUrl;
  }
};

export const waIntent = (phone, text) => {
  const query = text ? `&text=${encodeURIComponent(text)}` : "";
  const fallback = encodeURIComponent(
    text ? `https://wa.me/${phone}?text=${encodeURIComponent(text)}` : `https://wa.me/${phone}`
  );
  return `intent://send?phone=${phone}${query}#Intent;scheme=whatsapp;package=com.whatsapp;S.browser_fallback_url=${fallback};end`;
};

export const IG_INTENT = `intent://instagram.com/barberlatin_studio_jordan/#Intent;scheme=https;package=com.instagram.android;S.browser_fallback_url=${encodeURIComponent(
  "https://www.instagram.com/barberlatin_studio_jordan/"
)};end`;
